// Add this to a new JavaScript file in your assets folder
document.addEventListener("DOMContentLoaded", () => {
  // This script will help restore editor functionality

  // Function to check if we're in the Shopify editor
  function isInShopifyEditor() {
    return window.Shopify && window.Shopify.designMode
  }

  // Only run this in the Shopify editor
  if (isInShopifyEditor()) {
    console.log("Detected Shopify editor - restoring functionality")

    // Remove any inline styles that might be interfering with the editor
    document.querySelectorAll('[style*="!important"]').forEach((el) => {
      // Store the original style in a data attribute
      el.setAttribute("data-original-style", el.getAttribute("style"))
      // Remove the style attribute to allow editor to work
      el.removeAttribute("style")
    })

    // Re-apply styles when leaving the editor
    window.addEventListener("message", (event) => {
      if (event.data.message === "Shopify.API.remoteUi.editorStateChange") {
        if (!event.data.payload.isDesignMode) {
          // We've left the editor, re-apply styles
          document.querySelectorAll("[data-original-style]").forEach((el) => {
            el.setAttribute("style", el.getAttribute("data-original-style"))
          })
        }
      }
    })
  }
})
